/* ============================================================
   Snagged Goods — product page enhancements
   1. Shows the price on each option pill, but only on
      single-option products where the prices actually differ.
   2. Sticky add-to-cart bar on mobile once the real button
      scrolls out of view.

   Works on both product templates this store uses: the custom
   nearfield one and stock Dawn. Variant data comes from
   Shopify's own /products/<handle>.js endpoint, so nothing here
   depends on theme internals. If the hooks are missing the
   script exits quietly and the page renders as before.
   ============================================================ */
(function () {
  'use strict';

  if (window.__sgPdpEnhance) return;
  window.__sgPdpEnhance = true;

  var MOBILE = 749;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
    }
  }

  function init() {
    var form = document.querySelector('form.shopify-product-form');
    if (!form) return;

    var atc = form.querySelector('button.nf-add') ||
              form.querySelector('button[name="add"]') ||
              form.querySelector('[name="add"]');
    if (!atc) return;

    buildSticky(form, atc);
    decoratePills();
  }

  /* ---------- 1. Price ladder on the pills ---------- */

  // Returns [{ key:'option1', pills:[{el, value, host}] }] for whichever
  // product form this theme rendered — the custom nearfield one or stock Dawn.
  function optionGroups() {
    var groups = [];

    var nf = document.querySelectorAll('.nf-opt[data-index]');
    if (nf.length) {
      Array.prototype.forEach.call(nf, function (g) {
        var idx = parseInt(g.getAttribute('data-index'), 10);
        if (isNaN(idx)) return;
        var pills = [];
        Array.prototype.forEach.call(g.querySelectorAll('button.nf-sw[data-nf-value]'), function (b) {
          pills.push({ el: b, value: b.getAttribute('data-nf-value'), host: b });
        });
        if (pills.length) groups.push({ key: 'option' + (idx + 1), pills: pills, wrap: g.querySelector('.nf-swatches') });
      });
      return groups;
    }

    var sets = document.querySelectorAll('variant-selects fieldset, variant-radios fieldset');
    Array.prototype.forEach.call(sets, function (fs, i) {
      var pills = [];
      Array.prototype.forEach.call(fs.querySelectorAll('input[type="radio"]'), function (r) {
        var label = fs.querySelector('label[for="' + (r.id || '') + '"]') ||
                    (r.nextElementSibling && r.nextElementSibling.tagName === 'LABEL' ? r.nextElementSibling : null);
        if (label) pills.push({ el: r, value: r.value, host: label });
      });
      if (pills.length) groups.push({ key: 'option' + (i + 1), pills: pills, wrap: fs });
    });
    return groups;
  }

  function decoratePills() {
    var groups = optionGroups();
    if (!groups.length) return;

    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;

    fetch('/products/' + m[1] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;

        // Price per pill is only honest on single-option products (the rugs).
        // On a two-option product the price depends on the other option too, so a
        // single number per pill would contradict the buy box. Those still get
        // their sold-out values marked, just no prices.
        var singleOption = !p.options || p.options.length === 1;

        groups.forEach(function (group) {
          if (group.pills.length < 2) return;

          var byValue = {};
          p.variants.forEach(function (v) {
            var val = v[group.key];
            if (val == null) return;
            var slot = byValue[val] || (byValue[val] = { price: null, available: false });
            if (slot.price === null || v.price < slot.price) slot.price = v.price;
            if (v.available) slot.available = true;
          });

          var prices = {};
          Object.keys(byValue).forEach(function (k) {
            if (byValue[k].price !== null) prices[byValue[k].price] = 1;
          });
          var laddered = singleOption && Object.keys(prices).length > 1;

          if (laddered && group.wrap) group.wrap.classList.add('nf-swatches--priced');

          group.pills.forEach(function (pill) {
            var slot = byValue[pill.value];
            if (!slot) return;

            if (!slot.available) pill.host.classList.add('nf-sw--out');

            if (!laddered || slot.price === null) return;
            if (pill.host.querySelector('.nf-sw-price')) return;

            var span = document.createElement('span');
            span.className = 'nf-sw-price';
            span.setAttribute('aria-hidden', 'true'); // price is already in the buy box
            span.textContent = money(slot.price, p.variants[0].price_currency || 'USD');
            pill.host.appendChild(span);
            pill.host.classList.add('nf-sw--priced');
          });
        });
      })
      .catch(function () { /* leave the pills exactly as the theme rendered them */ });
  }

  /* ---------- 2. Sticky mobile add to cart ---------- */

  function buildSticky(form, atc) {
    if (document.querySelector('.sg-sticky')) return;

    var titleEl = document.querySelector('.nf-title, .nf-h1, .product__title h1, h1');
    var priceEl = document.querySelector('.nf-pricebox .p') ||
                  document.querySelector('.nf-pricebox') ||
                  document.querySelector('.price__container') ||
                  document.querySelector('.price');

    // Dawn's price block includes the words "Regular price" / "Sale price" and a
    // struck-through compare-at. Take the first money value, which is the one
    // rendered large and bold.
    function readPrice() {
      if (!priceEl) return '';
      var txt = priceEl.textContent || '';
      var hit = txt.match(/[£$€]\s?[\d,]+(?:\.\d{2})?/);
      return hit ? hit[0] : txt.trim();
    }

    var bar = document.createElement('div');
    bar.className = 'sg-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');

    var meta = document.createElement('div');
    meta.className = 'sg-sticky__meta';

    var t = document.createElement('span');
    t.className = 'sg-sticky__title';
    t.textContent = titleEl ? titleEl.textContent.trim() : '';

    var pr = document.createElement('span');
    pr.className = 'sg-sticky__price';
    pr.textContent = readPrice();

    meta.appendChild(t);
    meta.appendChild(pr);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sg-sticky__btn';
    btn.textContent = (atc.textContent || 'Add to cart').trim();
    btn.addEventListener('click', function () {
      atc.click();
    });

    bar.appendChild(meta);
    bar.appendChild(btn);
    document.body.appendChild(bar);
    document.body.classList.add('sg-has-sticky');

    function syncState() {
      if (priceEl) pr.textContent = readPrice();
      var label = (atc.textContent || '').trim();
      if (label) btn.textContent = label;
      btn.disabled = !!atc.disabled;
    }

    // The theme rewrites the buy box on variant change; mirror whatever it lands on.
    form.addEventListener('click', function () { setTimeout(syncState, 180); });
    form.addEventListener('change', function () { setTimeout(syncState, 180); });
    document.addEventListener('change', function () { setTimeout(syncState, 260); });
    if (window.MutationObserver && priceEl) {
      new MutationObserver(syncState).observe(priceEl, {
        childList: true, characterData: true, subtree: true
      });
    }
    syncState();

    // Show only once the real button has scrolled past.
    function toggle(on) {
      if (window.innerWidth > MOBILE) on = false;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        toggle(!entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -10% 0px' }).observe(atc);
    } else {
      window.addEventListener('scroll', function () {
        var r = atc.getBoundingClientRect();
        toggle(r.bottom < 0);
      }, { passive: true });
    }

    window.addEventListener('resize', function () {
      if (window.innerWidth > MOBILE) toggle(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function () {
    window.__sgPdpEnhance = false;
    init();
    window.__sgPdpEnhance = true;
  });
})();
